export interface PostRequestPayload {
  groupRegistrationId: string;
  groupId: string;
  teamId: string;
  partnerEmail: string;
  partnerName?: string;
}

export const getTournamentInviteByEmailApi = (tournamentId: string) =>
  `/v1/tournaments/${tournamentId}/invite-by-email`;
